import React, { useState, useEffect } from 'react'
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import Select from "react-select";
import { useFormik } from 'formik';
import { getJobOrderEmployeeList, getUnusedQuotationList } from '../../../../Redux/action/Joborder/JoborderAction';
import { toast } from 'react-toastify';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { adminMainUrl } from '../../../../Config';
import axios from 'axios';

const JobOrderAdd = ({ accessedModules, accessedPermission }) => {
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [disableSubmit, setDisableSubmit] = useState(false);
    const [disableQuotationField, setDisableQuotationField] = useState(false);

    const queryParams = new URLSearchParams(location.search);
    const qId = queryParams.get('q_id'); // Retrieve the value of q_id

    const urlString = window.location.href;
    const url = new URL(urlString);
    const path = url.pathname.slice(1);
    const searchParams = url.search;
    const q = path + searchParams;
    const token = Cookies.get('token');
    const user_id = Cookies.get('flexichain_user_id')
    useEffect(() => {
        if (token && user_id) {
            dispatch(getUnusedQuotationList(token, user_id));
            dispatch(getJobOrderEmployeeList(token, user_id));
        } else {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        }

    }, [token, user_id]);


    const {
        loadingUnusedQuotationList,
        UnusedQuotationListError,
        UnusedQuotationList,

        loadingJobOrderEmployeeList,
        JobOrderEmployeeListError,
        JobOrderEmployeeList,
    } = useSelector(state => state?.JoborderReducer);


    const [quotationOption, setQuotationOptions] = useState([]);
    const [loadingQuotation, setLoadingQuotation] = useState(false);

    const [branchOption, setBranchOption] = useState([]);
    const [loadingBranch, setLoadingBranch] = useState(false);

    const [companyName, setCompanyName] = useState("");



    const [employeeOptions, setEmployeeOptions] = useState([]);
    const [loadingEmployee, setLoadingEmployee] = useState([]);
    const [quoteOptionArr, setQuoteOptionArr] = useState([]);
    useEffect(() => {
        if (loadingJobOrderEmployeeList) {
            setLoadingEmployee(true);
        } else {
            setLoadingEmployee(false);
        }

        if (JobOrderEmployeeList) {
            let arr = [];
            JobOrderEmployeeList.map(val => { arr.push({ value: val.user_id, label: val.name }) });
            setEmployeeOptions(arr);
        }
    }, [loadingJobOrderEmployeeList, JobOrderEmployeeListError, JobOrderEmployeeList]);

    const initialValues = {
        trans_mode: "",
        trans_type: "",
        quotation_id: "",
        customer_id: "",
        customer_branch_id: "",
        job_owner_id: "",
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: (values) => {
            // console.log(values);
            setDisableSubmit(true);
            if (!values.customer_branch_id) {
                values.customer_branch_id = null;
            }
            try {
                let config = {
                    headers: {
                        'auth-token': Cookies.get('token'),
                        'user_id': Cookies.get('flexichain_user_id')
                    }
                }
                axios.post(`${adminMainUrl}/api/jobOrder/add`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response?.data?.msg);
                            setDisableSubmit(false);
                            navigate(`/flexichain/job-order/edit/${btoa(response.data.data.id)}`)
                        } else {
                            toast.error(response?.data?.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error)
                        toast.error(error.response.data.msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });



    let [disableTransportMode, setDisableTransportMode] = useState(false);
    let [disableTransportType, setDisableTransportType] = useState(false);


    useEffect(() => {
        if (qId) {
            let quotation_id = atob(qId);
            setQuotationOptions(quoteOptionArr);
            if (quotation_id) {
                setDisableQuotationField(true);
                let findQIDQuotation = quoteOptionArr.find(v => v.value == quotation_id);
                if (findQIDQuotation) {
                    setDisableTransportMode(true);
                    setDisableTransportType(true);
                    formik.setFieldValue("trans_mode", findQIDQuotation.trans_mode);
                    formik.setFieldValue("trans_type", findQIDQuotation.trans_type);
                }
                // console.log(findQIDQuotation);
                formik.setFieldValue('quotation_id', Number(quotation_id));
                handleChangeCompanyBranch(Number(quotation_id));
            } else {
                setDisableQuotationField(false);
                setDisableTransportMode(false);
                setDisableTransportType(false);
            }
        } else {
            setDisableQuotationField(false);
            setDisableTransportMode(false);
            setDisableTransportType(false);
        }
    }, [qId, quoteOptionArr]);





    useEffect(() => {
        if (loadingUnusedQuotationList) {
            setLoadingQuotation(true);
        } else {
            setLoadingQuotation(false);
        }

        if (UnusedQuotationList) {
            let arr = [];
            UnusedQuotationList.map((val) => {
                const customerName = val.customer_data && val.customer_data.name ? `(${val.customer_data.name})` : "";
                const label = `${val.ship_quotation_no} ${customerName}`;

                const trans_mode = val.transport_mode;
                const trans_type = val.transport_type;
                arr.push({ value: val.id, label, trans_mode, trans_type });
            });
            // console.log("arr.arr", arr);
            setQuoteOptionArr(arr);
            // setQuotationOptions(arr);
        };

    }, [loadingUnusedQuotationList, UnusedQuotationListError, UnusedQuotationList]);

    const handleChangeCompanyBranch = (quotation_id) => {
        try {
            formik.setFieldValue("customer_id", "");
            formik.setFieldValue('branch_id', "");
            let config = { headers: { 'auth-token': token, 'user_id': user_id } };
            axios.get(`${adminMainUrl}/api/jobOrder/get-companydetails-on-quotation?quotation_id=${quotation_id}`, config)
                .then(response => {
                    if (response.status == 200) {
                        if (response.data) {
                            if (response.data.data) {
                                if (response.data.data.customer_data) {
                                    formik.setFieldValue('customer_id', response.data.data.customer_data.id);
                                    setCompanyName(`${response.data.data.customer_data?.name} ${response.data.data.customer_data?.alias ? `(${response.data.data.customer_data?.alias})` : ""} - ${response.data.data.customer_data?.customerType}`);
                                    if (response.data.data.customer_data?.customer_branch) {
                                        if (Array.isArray(response.data.data.customer_data?.customer_branch)) {
                                            let arr = [];
                                            response.data.data.customer_data?.customer_branch.map(val => arr.push({ value: val.id, label: val.branch_name }));
                                            setBranchOption(arr);
                                        } else {
                                            setBranchOption([]);
                                        }
                                    } else {
                                        setBranchOption([]);
                                    }
                                } else {
                                    setCompanyName("");
                                    formik.setFieldValue('customer_id', "");
                                    setBranchOption([]);
                                }
                            }
                        }
                    } else {
                        console.log(response.data.msg);
                    }
                }).catch(err => {
                    console.log(err);
                })
        } catch (error) {
            // toast.error(error.message);
            console.log(error.message);
        }
    };

    const customStyles = {
        control: (base) => ({
            ...base,
            height: 29,
            minHeight: 29,
            display: 'flex',
            alignItems: 'center',
        }),
        placeholder: (base) => ({
            ...base,
            display: 'flex',
            alignItems: 'center',
            fontSize: '12px',
            fontWeight: "600",
            color: '#808080',
        }),
        menu: (base) => ({
            ...base,
            fontSize: '12px',
        }),
        option: (base) => ({
            ...base,
            fontSize: '12px',
        }),
        singleValue: (base) => ({
            ...base,
            fontSize: '12px',
            display: 'flex', // Ensure singleValue aligns center vertically
            alignItems: 'center',
        }),
    };


    useEffect(() => {
        if (formik.values.trans_mode && formik.values.trans_type && !qId) {
            //find all the Quotation -> with these filters
            let findArr = quoteOptionArr.filter(v => v.trans_mode == formik.values.trans_mode && v.trans_type == formik.values.trans_type);
            setQuotationOptions(findArr);
        }
    }, [formik.values.trans_mode, formik.values.trans_type, qId])

    return (
        <>
            <div className="page-wrapper">
                <div className="content">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <h6>Add Job Order</h6>
                            </div>
                            {/* Filter */}
                            <form onSubmit={formik.handleSubmit}>
                                <div className="row">
                                    <div className="col-md-6 mt-2">
                                        <div className='ms-2'>
                                            <label htmlFor="" className='form-label  mb-0'>
                                                Transport Mode
                                            </label>
                                            <div className="icon-forms mb-3 mb-sm-0">
                                                <select
                                                    className="form-control form-control-sm"
                                                    name="trans_mode"
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.trans_mode}
                                                    disabled={disableTransportMode}
                                                >
                                                    <option value="">-</option>
                                                    <option value="Air">Air</option>
                                                    <option value="Sea">Sea</option>
                                                    {/* <option value="Road">Road</option>
                                                            <option value="Rail">Rail</option> */}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 mt-2">
                                        <div className='ms-2'>
                                            <label htmlFor="" className='form-label  mb-0'>
                                                Transport Type
                                            </label>
                                            <div className="icon-forms mb-3 mb-sm-0">
                                                <select
                                                    className="form-control form-control-sm"
                                                    name="trans_type"
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.trans_type}
                                                    disabled={disableTransportType}
                                                >
                                                    <option value="">-</option>
                                                    <option value="Import">Import</option>
                                                    <option value="Export">Export</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-6 mt-2">
                                        <div className='ms-2'>
                                            <label htmlFor="" className='form-label  mb-0'>
                                                Quotation
                                            </label>
                                            <div className="icon-forms mb-3 mb-sm-0">
                                                <Select
                                                    // styles={{ control: customControlStyles }}
                                                    className='custom-selector'
                                                    options={quotationOption}
                                                    styles={customStyles}
                                                    name="quotation_id"
                                                    onChange={option => {
                                                        formik.setFieldValue('customer_branch_id', "")
                                                        formik.setFieldValue('quotation_id', option.value);
                                                        handleChangeCompanyBranch(option.value);
                                                    }}
                                                    value={quotationOption.find(option => option.value === formik.values.quotation_id || null)}
                                                    isLoading={loadingQuotation}
                                                    isDisabled={disableQuotationField}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 mt-2">
                                        <div className='ms-2'>
                                            <label htmlFor="" className='form-label  mb-0'>
                                                Customer
                                            </label>
                                            <div className="icon-forms mb-3 mb-sm-0">
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    value={companyName}
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-6 mt-2">
                                        <div className='ms-2'>
                                            <label htmlFor="" className='form-label  mb-0'>
                                                Branch
                                            </label>
                                            <div className="icon-forms mb-3 mb-sm-0">
                                                <Select
                                                    className='custom-selector'
                                                    options={branchOption}
                                                    styles={customStyles}
                                                    name="customer_branch_id"
                                                    onChange={option => {
                                                        formik.setFieldValue('customer_branch_id', option.value);
                                                    }}
                                                    value={branchOption.find(option => option.value === formik.values.customer_branch_id || null)}
                                                // value={}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {/* <div className="col-md-6 mt-2">
                                                <div className='ms-2 input_box_section'>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        Sales Person
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <Select
                                                            className='mt-2 custom-selector '
                                                            options={customerOptions}
                                                            name="role_id"
                                                        />
                                                    </div>
                                                </div>
                                            </div> */}




                                    <div className="col-md-6 mt-2">
                                        <div className='ms-2 '>
                                            <label htmlFor="" className='form-label  mb-0'>
                                                Job Owner
                                            </label>
                                            <div className="icon-forms mb-3 mb-sm-0">
                                                <Select
                                                    className='custom-selector'
                                                    options={employeeOptions}
                                                    styles={customStyles}
                                                    name="job_owner_id"
                                                    onChange={option => {
                                                        formik.setFieldValue('job_owner_id', option.value);
                                                    }}
                                                // value={formik.values.job_owner_id}
                                                // isLoading={loadingEmployee}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="row d-flex justify-content-end mt-2">
                                    <div className="col-md-6 d-flex justify-content-end">
                                        <button type="submit" className="btn btn-sm btn-danger" disabled={disableSubmit}>
                                            {disableSubmit ? <><i className="fas fa-spinner fa-spin"></i> Saving...</> : "Save and Next"}
                                        </button>
                                    </div>
                                </div>
                            </form>


                        </div>
                    </div>
                </div>
            </div >
        </>

    )
}

export default JobOrderAdd